export default __webpack_public_path__ + "static/ville-levis-410088840f66eef61985cd65a7a98db1.png";